import { createColumn, createDropdownColumn } from "../components/Table/Table";

// Date and User columns common
const DoorEnumsDateUserColumn: State.Column[] = [
  createColumn(
    "Created By",
    (enumeration: Api.EventEnumeration) => enumeration.createdBy,
    "enumeration.createdBy",
    false
  ),
  createColumn(
    "Created Date",
    (enumeration: Api.EventEnumeration) => enumeration.createdDate,
    "enumeration.createdDate",
    false
  ),
  createColumn(
    "Modified By",
    (enumeration: Api.EventEnumeration) => enumeration.modifiedBy,
    "enumeration.modifiedBy",
    false
  ),
  createColumn(
    "Modified Date",
    (enumeration: Api.EventEnumeration) => enumeration.modifiedDate,
    "enumeration.modifiedDate",
    false
  )
];

export const commonEnumColumns: State.Column[] = [
  createColumn(
    "Value",
    (enumeration: Api.EventEnumeration) => enumeration.enumValue,
    "enumeration.enumValue",
    true,
    80
  ),
  createColumn(
    "Enumeration",
    (enumeration: Api.EventEnumeration) => enumeration.enumName,
    "enumeration.enumName",
    true
  ),
  createColumn(
    "Comment",
    (enumeration: Api.EventEnumeration) => enumeration.comment,
    "enumeration.comment",
    true
  ),
  ...DoorEnumsDateUserColumn
];

export const eventTypeEnumColumns: State.Column[] = [
    createColumn(
      "Value",
      (enumeration: Api.EventTypesEnum) => enumeration.enumValue,
      "enumeration.enumValue",
      true,
      80
    ),
    createColumn(
      "Enumeration",
      (enumeration: Api.EventTypesEnum) => enumeration.enumName,
      "enumeration.enumName",
      true
    ),
    createDropdownColumn(
      "Event Class",
      (enumeration: Api.EventTypesEnum) => enumeration.eventClassEnumName,
      "enumeration.eventClassEnumName",
      true
    ),
    createColumn(
      "Comment",
      (enumeration: Api.EventTypesEnum) => enumeration.comment,
      "enumeration.comment",
      true
    ),
    ...DoorEnumsDateUserColumn
  ];